import React from "react";
import PropTypes from "prop-types";
import { css } from "glamor";
import Color from "color";

import styles from "./styles.module.scss";

const backgroundOpacityPresets = {
  light: 0.25,
  medium: 0.5,
  dark: 0.75,
  solid: 1
};

const Chip = ({
  backgroundOpacity = null,
  backgroundOpacityPreset = "solid",
  className = null,
  color = null,
  label,
  onClick = null,
  profiling = "background",
  size = "medium"
}) => {
  const ChipElement = onClick ? "button" : "span";

  const chipColor = Color(color);
  const chipColorWithOpacity = Color(color).alpha(
    backgroundOpacity || backgroundOpacityPresets[backgroundOpacityPreset]
  );

  const chipRule = css({
    ...(color && {
      "--border-color": profiling === "borderless" ? "transparent" : chipColor,
      "--text-color":
        profiling === "background" && chipColorWithOpacity
          ? chipColor.isDark()
            ? "white"
            : "black"
          : chipColor,
      "--bg-color":
        profiling === "background" ? chipColorWithOpacity : "transparent",
      backgroundColor:
        profiling === "background" ? chipColorWithOpacity : "transparent"
    })
  });

  return (
    <ChipElement
      className={`${styles.chip} ${chipRule} ${className || ""} ${
        styles[size]
      }`}
      data-chip-type={profiling}
      {...(onClick ? { onClick } : {})}
    >
      {label}
    </ChipElement>
  );
};

Chip.propTypes = {
  backgroundOpacity: PropTypes.number,
  backgroundOpacityPreset: PropTypes.oneOf([
    "light",
    "medium",
    "dark",
    "solid"
  ]), // light = 0.25, medium = 0.5, dark = 0.75, solid = 1
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClick: PropTypes.func,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  profiling: PropTypes.oneOf(["background", "border", "borderless", "shadow"]), // todo: add this
  size: PropTypes.oneOf(["small", "medium", "large"])
};

export default Chip;
